var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcContractServiceBody2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 260,
    viewBox: "0 0 256 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2031_919)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 202.518,
    y: 80.1338,
    width: 10.7248,
    height: 57.1988,
    transform: "rotate(8.28361 202.518 80.1338)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.383,
    cy: 73.4324,
    r: 32,
    transform: "rotate(-10.093 210.383 73.4324)",
    fill: "#BDE9FF",
    stroke: "#D9D9D9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.365 132.434L166.095 134.679C161.482 137.846 157.565 141.924 154.588 146.662L144.483 162.739L162.063 185.623L194.576 182.336C199.051 181.883 202.898 178.966 204.54 174.778L206.272 170.362C206.773 169.085 207.107 167.749 207.267 166.387L208.22 158.28L210.506 156.254C213.112 153.944 214.328 150.446 213.718 147.017L212.852 142.154L216.219 141.554C218.94 141.07 220.978 138.79 221.155 136.033L221.517 130.415C221.59 129.285 220.71 128.32 219.578 128.288L186.6 127.353C180.462 127.179 174.427 128.958 169.365 132.434Z",
    fill: "#FFDCD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.603 154.993L173.699 194.3L165.448 200.827L134.352 161.52L142.603 154.993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.399 159.23L167.23 203.258L21.6475 318.431L-13.1835 274.403L132.399 159.23Z",
    fill: "#374969"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.88,
    cy: 208.579,
    r: 3.38955,
    transform: "rotate(51.0376 148.88 208.579)",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.792,
    cy: 216.83,
    r: 3.38955,
    transform: "rotate(51.0376 138.792 216.83)",
    fill: "#D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2031_919"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 260,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcContractServiceBody2);
export default __webpack_public_path__ + "static/media/IcContractServiceBody2.e7a1a9af566f65ec81be44b6dc9a5150.svg";
export { ForwardRef as ReactComponent };